module.exports = __webpack_public_path__ + "static/media/banner_onenavi.1d4ae8e4.png";